import Swiper, { Navigation, Pagination } from 'swiper';

jQuery(document).ready(function($) {

    Swiper.use([Navigation, Pagination]);

    if ($('.wpg-abo-review-items').length) {
        var aboReviewItemsSlider = new Swiper('.wpg-abo-review-items', {
            slidesPerView: 1.4,
            slidesPerGroup: 1,
            loop: true,
            autoplay: false,
            spaceBetween: 30,
            pagination: {
                el: '.wpg-abo-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.wpg-abo-arrow-next',
                prevEl: '.wpg-abo-arrow-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,       
                },
                991: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },

            }
        });
    }


    function showCountMessage(inputId) {
        var textArea = $(inputId);
        var maxLength = textArea.attr('maxlength');
        var counter = textArea.next().find('.count-message');

        counter.html(maxLength);

        textArea.keyup(function() {
            counter.html(maxLength - $(this).val().length);
        });
    }

    showCountMessage('#wpg_abo_review_message');

    $('#wpg-abo-review-form form').submit(function(e) {
        e.preventDefault();

        var formParent = $(this).parent();

        formParent.addClass('loading');

        $.post($(this).data('url'), {
            action: 'sendReview',
            data: $(this).serialize(),
            dataType: 'json',
        }, function(data) {
            formParent.html(data.data.html);
        }).fail(function(data) {
            $.each(data.responseJSON.data.errors, function(field_name, error) {
                formParent.find('[name='+field_name+']').addClass('is-invalid').after(
                    "<div class='invalid-feedback'>"+error+"</div>"
                );
            });
        }).always(function() {
            formParent.removeClass('loading');
            $('.modal-title').addClass('d-none');
        });
    });

    $('#wpg-abo-review-form form .wpg-abo-stars .wpg-abo-star').on('click', function() {
        var rating = $(this).data('nr');

        $('#wpg_abo_review_stars').val(rating);
        $(this).parent().attr('data-checked', rating);

        $('#wpg-abo-review-form form .wpg-abo-star-checked').removeClass('wpg-abo-star-checked');

        $('#wpg-abo-review-form form .wpg-abo-stars .wpg-abo-star').each( function() {    
            if($(this).data('nr') <= rating) {
                $(this).addClass('wpg-abo-star-checked');
            }
        });
    });
    

    $('.wpg-abo-details').on('shown.bs.modal', function (e) {
        $('.wpg-abo-text-read-toggle').on('click', function() {
            var contentWrap = $(this).parents('.wpg-abo-text-read-content-wrapper');
            var shortContent = contentWrap.find('.wpg-abo-text-read-short-content');
            var completeContent = contentWrap.find('.wpg-abo-text-read-complete-content');
    
            if($(this).hasClass('wpg-abo-text-read-more')) {
                shortContent.hide();
                completeContent.show();
            }
    
            if($(this).hasClass('wpg-abo-text-read-less')) {
                completeContent.hide();
                shortContent.show();
            }
        });

        var modal_slider = $(this).find('.wpg-abo-modal-image-container');

        if (modal_slider.hasClass('swiper-container-initialized')) {
            modal_slider[0].swiper.destroy(modal_slider[0]);
        }
        
        var modalSlider = new Swiper( modal_slider[0], {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            autoplay: {
                delay: 2000,
            },
            pagination: {
                el: '.wpg-abo-pagination',
                type: 'bullets',
                clickable: true
            }
        });
    })


    var $moreSubscriptionsGroup = $('#moreSubscriptionsGroup');
    $moreSubscriptionsGroup.on('show.bs.collapse','.collapse', function() {
        $moreSubscriptionsGroup.find('.collapse.show').collapse('hide');
    });

    $(".usp-item-read-more").click(function() { 
        $(this).next().toggle();
        $(this).addClass( "d-none" );
    });
    
    $(".usp-item-read-less").click(function() {  
        $(this).closest(".read-more-usp-block").toggle();
        $(this).closest(".wpg-abo-usps").find(".usp-item-read-more").removeClass( "d-none" );
    });
});
